import './IconPause2.css';
import React from 'react';
var IconHeart = function IconHeart(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 18 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 22 : _ref$height,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("svg", {
    className: "".concat(className, " ").concat(styles),
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 18 22"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M1 0a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1zm8 0a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1z",
    transform: "translate(4 2)"
  }));
};
var styles = "s1t4r9dr";
export default IconHeart;